import React, { useEffect, useRef } from "react";
import { getParsedNumber } from "../utils/Common";
import { numberFieldInvalidCharacters } from "../constant/constants";

function CustomInput({
  label,
  value,
  setValue,
  placeholder,
  name = "",
  shouldSetValueSetObj = false,
  disabled = false,
  required = false,
  password = false,
  number = false,
  showPadding = true,
  highlight = false,
  onPressEnter,
  inputClasses = "",
  onlyNumeric = false,
  isDecimalAllowed = false, // it should be used when onlyNumber is true
  isStartingZeroAllowed = true,
  isLableVertical = true,
  max = false,
  labelClass = "font-uregular",
  rightLabelText = "",
  maxLength = null,
  allowNumberAndSymbols = false,
  alphaNumericWithDot=false,
  allowNumberAndHyphen=false,
}) {
  const inputRef = useRef(null);
  let baseStyle = `w-full flex ${isLableVertical ? "flex-col" : ""} ${showPadding ? "px-[16px]" : ""} mb-[12px]`;
  let inputCss = {
    borderColor: highlight ? "red" : "#D5D8DB",
  };
  const handleKeyPress = (e) => {
    // Check if the key pressed is "Enter"
    if (e.key === "Enter") {
      onPressEnter();
      // Here you can trigger your desired logic
    }

    // If a number field is only numberic and decimal values allowed, then it will not allow the valid characters like e, -
    if (onlyNumeric && isDecimalAllowed && numberFieldInvalidCharacters.includes(e.key)) {
      e.preventDefault();
    }
  };

    useEffect(() => {
    const el = inputRef.current;
    if (!el) return;

    const handleWheel = (e) => {
      e.preventDefault();
    };

    const handleTouchMove = (e) => {
      e.preventDefault(); // stop touch scroll changing value
    };

    // Add non-passive listener so preventDefault works
    el.addEventListener("wheel", handleWheel, { passive: false });
    el.addEventListener("touchmove", handleTouchMove, { passive: false });

    return () => {
      el.removeEventListener("wheel", handleWheel);
      el.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  return (
    <div className={baseStyle}>
      <div className={`text-sm flex flex-row ${labelClass}`}>
        <div>{label}</div>
        {required && <div className="font-ubold text-red-700 ml-[2px]">*</div>}
      </div>
      <input
        ref={inputRef}
        name={name}
        disabled={disabled}
        onKeyDown={handleKeyPress}
        style={inputCss}
        value={value}
        type={password ? "password" : number ? "number" : "text"}
        className={`w-full rounded-[5px] border-[1px] border-grey font-uregular px-[8px] py-[4px] ${inputClasses}`}
        placeholder={placeholder}
        onChange={(e) => {
          const { name, value } = e.target;
          
          // Apply logic if onlyNumeric is true
          if (onlyNumeric) {
            // Disallow leading zero when isStartingZeroAllowed is false
            if (!isStartingZeroAllowed && value.startsWith("0")) {
              return;
            }

            // Block non-numeric input
            if (value !== "" && /^(\d+(\.\d+)?|\.\d+)$/.test(value) === false && isDecimalAllowed) {
              console.log("----value----", value);
              return;
            } else if (/[^\d]/.test(value) && !isDecimalAllowed) {
              console.log("============only digits allowed=======", value);
              return;
            }
          }

          if ((number || onlyNumeric) && max !== false && getParsedNumber(value) > max) {
            return;
          }

          // Apply max character limit
          if (maxLength && value.length > maxLength) {
            return;
          }

         // If onlyNumeric and allowSymbols are true, allow only digits and specified symbols in value
          if (allowNumberAndSymbols) {
            if (/[^0-9!@#$%&()?":{}|<>_\-+=/\\[\]`~;']/g.test(value)) {
              return;
            }
          }

          // allow only digits and hyphen in value
          if (allowNumberAndHyphen) {
            if (/[^0-9-']/g.test(value)) {
              return;
            }
          }

          // ✅ Allow only A–Z, 0–9, hyphen (-), and slash (/)
          if (alphaNumericWithDot && /[^A-Za-z0-9/.]/.test(value)) {
            return;
          }

          if (name && shouldSetValueSetObj) {
            setValue({ name, value });
          } else {
            setValue(value);
          }
        }}
      />
      {rightLabelText.length > 0 && <div className="pl-2 py-1">{rightLabelText}</div>}
      {maxLength > 0 && <div className="my-1 text-[12px] text-gray-600 italic">Char limit {maxLength} ({value.length})</div>}
    </div>
  );
}

export default CustomInput;
